import * as sharedTransmissionTypesSpecifications from '../../common/vehicleSpecifications/transmissionTypes.js'

// Define only the vehicle specifications that are different from the common ones
export const TRANSMISSION_TYPES = {...sharedTransmissionTypesSpecifications.TRANSMISSION_TYPES}
export const TRANSMISSION_TYPES_IDS = {...sharedTransmissionTypesSpecifications.TRANSMISSION_TYPES_IDS}
